// ------------------------------------
// Página lateral
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $pageSide = $('.page-side-wrp');
  const $btnToggle = $('[data-side-toggle]');

  // Abre ou fecha a lateral ao clicar no botão
  $btnToggle.on('click', function (ev) {
    ev.preventDefault();
    const idPage = $(this).data('side-toggle');
    sideToggle(idPage);
  });

  // Fecha a lateral ao clicar fora
  $pageSide.not('.page-force, .page-nobackdrop').on('click', function (ev) {
    if (ev.target == this) {
      sideClose($(this).attr('id'));
    }
  });

  // Fecha a lateral ao pressionar a tecla ESC
  $(document).on('keyup', function (ev) {
    if (ev.keyCode == 27) {
      const $sidesOpen = $('.page-side-wrp.active:not(.page-force)');
      const pagesLength = $sidesOpen.length;
      if (pagesLength > 0) {
        const $lastPage = $($sidesOpen[pagesLength - 1]);
        sideClose($lastPage.attr('id'));
      }
    }
  });
})();

// Abre a lateral
function sideOpen(idPage) {
  $('body').addClass('side-open');
  $('#' + idPage).addClass('active');
  $('#' + idPage).trigger('side-open');
}

// Fecha a lateral
function sideClose(idPage) {
  $('#' + idPage).removeClass('active');
  $('#' + idPage).trigger('side-close');
  if ($('.page-side-wrp.active').length === 0) {
    $('body').removeClass('side-open');
  }
}

// Abre ou fecha a lateral
function sideToggle(idPage) {
  const $pageSide = $('#' + idPage);
  if ($pageSide.hasClass('active')) {
    sideClose(idPage);
  } else {
    sideOpen(idPage);
  }
}
